angular.module('qkr').factory('timeZoneService', ($http, appConfig) => ({

        loadTimeZoneList() {
            return $http.get(appConfig.apiUrl + 'timeZone/list').then((response) => response.data);
        }
    }));



// WEBPACK FOOTER //
// ./src/services/timeZone.services.js